import {
  APPLICATION_TYPE_SETUP,
  APPLICATION_TYPE_SETUP_ERROR,
  APPLICATION_TYPE_SETUP_SUCCESS,
  APPLICATION_ONBOARDING_SETUP,
  APPLICATION_ONBOARDING_SETUP_SUCCESS,
  APPLICATION_ONBOARDING_SETUP_ERROR,
  GET_APPLICATION,
  GET_APPLICATION_SUCCESS,
  GET_APPLICATION_ERROR,
  DELETE_APPLICATION_ERROR,
  DELETE_APPLICATION_SUCCESS,
  DELETE_APPLICATION,
  RESET_APPLICATION,
  CREATE_APPLICATION_STEP,
  CREATE_APPLICATION_STEP_SUCCESS,
  CREATE_APPLICATION_STEP_ERROR,
  CREATE_ACCOUNT_TYPE,
  CREATE_ACCOUNT_TYPE_SUCCESS,
  CREATE_ACCOUNT_TYPE_ERROR,
  PATCH_ACCOUNT_TYPE,
  PATCH_ACCOUNT_TYPE_SUCCESS,
  PATCH_ACCOUNT_TYPE_ERROR,
  COMPLETE_APPLICATION,
  COMPLETE_APPLICATION_SUCCESS,
  COMPLETE_APPLICATION_ERROR,
  CREATE_APPLICATION,
  CREATE_APPLICATION_SUCCESS,
  CREATE_APPLICATION_ERROR,
  UPGRADE_APPLICATION,
  UPGRADE_APPLICATION_SUCCESS,
  UPGRADE_APPLICATION_ERROR,
  REFERRAL_ACCEPTED,
  REFERRAL_ACCEPTED_SUCCESS,
  REFERRAL_ACCEPTED_ERROR,
} from './applicationActionConstants';

// Create Application Type
export const applicationTypeSetup = (payload) => ({
  type: APPLICATION_TYPE_SETUP,
  payload,
});

export const applicationTypeSetupSuccess = (payload) => ({
  type: APPLICATION_TYPE_SETUP_SUCCESS,
  payload,
});

export const applicationTypeSetupError = (payload) => ({
  type: APPLICATION_TYPE_SETUP_ERROR,
  payload,
});

// Create Account Type
export const createAccountType = (payload) => ({
  type: CREATE_ACCOUNT_TYPE,
  payload,
});

export const createAccountTypeSuccess = (payload) => ({
  type: CREATE_ACCOUNT_TYPE_SUCCESS,
  payload,
});

export const createAccountTypeError = (payload) => ({
  type: CREATE_ACCOUNT_TYPE_ERROR,
  payload,
});

// Patch Account Type
export const patchAccountType = (payload) => ({
  type: PATCH_ACCOUNT_TYPE,
  payload,
});

export const patchAccountTypeSuccess = (payload) => ({
  type: PATCH_ACCOUNT_TYPE_SUCCESS,
  payload,
});

export const patchAccountTypeError = (payload) => ({
  type: PATCH_ACCOUNT_TYPE_ERROR,
  payload,
});

// Create and Control application onboarding Menu and Step
export const applicationOnboardingSetup = (payload) => ({
  type: APPLICATION_ONBOARDING_SETUP,
  payload,
});

export const applicationOnboardingSetupSuccess = (payload) => ({
  type: APPLICATION_ONBOARDING_SETUP_SUCCESS,
  payload,
});

export const applicationOnboardingSetupError = (payload) => ({
  type: APPLICATION_ONBOARDING_SETUP_ERROR,
  payload,
});

// Get Application
export const getApplication = (payload) => ({
  type: GET_APPLICATION,
  payload,
});

export const getApplicationSuccess = (payload) => ({
  type: GET_APPLICATION_SUCCESS,
  payload,
});

export const getApplicationError = (payload) => ({
  type: GET_APPLICATION_ERROR,
  payload,
});

// Delete Application
export const deleteApplication = (payload) => ({
  type: DELETE_APPLICATION,
  payload,
});

export const deleteApplicationSuccess = (payload) => ({
  type: DELETE_APPLICATION_SUCCESS,
  payload,
});

export const deleteApplicationError = (payload) => ({
  type: DELETE_APPLICATION_ERROR,
  payload,
});

export const resetApplication = () => ({
  type: RESET_APPLICATION,
});

// Create Application Type
export const createApplicationStep = (payload) => ({
  type: CREATE_APPLICATION_STEP,
  payload,
});

export const createApplicationStepSuccess = (payload) => ({
  type: CREATE_APPLICATION_STEP_SUCCESS,
  payload,
});

export const createApplicationStepError = (payload) => ({
  type: CREATE_APPLICATION_STEP_ERROR,
  payload,
});

// Complete application

export const completeApplication = (payload) => ({
  type: COMPLETE_APPLICATION,
  payload,
});

export const completeApplicationSuccess = (payload) => ({
  type: COMPLETE_APPLICATION_SUCCESS,
  payload,
});

export const completeApplicationError = (payload) => ({
  type: COMPLETE_APPLICATION_ERROR,
  payload,
});

// Create Application
export const createApplication = (payload) => ({
  type: CREATE_APPLICATION,
  payload,
});

export const createApplicationSuccess = (payload) => ({
  type: CREATE_APPLICATION_SUCCESS,
  payload,
});

export const createApplicationError = (payload) => ({
  type: CREATE_APPLICATION_ERROR,
  payload,
});

// Upgrade Application
export const upgradeApplication = (payload) => ({
  type: UPGRADE_APPLICATION,
  payload,
});

export const upgradeApplicationSuccess = (payload) => ({
  type: UPGRADE_APPLICATION_SUCCESS,
  payload,
});

export const upgradeApplicationError = (payload) => ({
  type: UPGRADE_APPLICATION_ERROR,
  payload,
});

// Referral Accepted
export const referralAccepted = (payload) => ({
  type: REFERRAL_ACCEPTED,
  payload,
});

export const referralAcceptedSuccess = (payload) => ({
  type: REFERRAL_ACCEPTED_SUCCESS,
  payload,
});

export const referralAcceptedError = (payload) => ({
  type: REFERRAL_ACCEPTED_ERROR,
  payload,
});
